<template>
  <div class="bg-white min-h-screen flex flex-col">
    <TSkipLink />
    <RenderTemplateHeader />
    <TContainer>
      <TGrid>
        <main id="main" class="col-span-12 lg:col-span-8">
          <slot></slot>
        </main>

        <div class="sticky top-8 lg:col-span-4 lg:col-start-9 z-10">
          <div
            class="h-full absolute z-0 top-0 bottom-0 left-0 right-0 mx-auto flex w-full items-start justify-end"
          >
            <aside class="w-full sticky top-24 shrink-0">
              <slot name="aside-desktop"></slot>
            </aside>
          </div>
        </div>
      </TGrid>
    </TContainer>
  </div>
</template>

<script setup lang="ts">
import { useTemplateDataComposable } from '~~/modules/template/composables/useTemplateDataComposable'

await useTemplateDataComposable({
  template: 'standard-aside',
})
</script>
